module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/thumbs/3-286e6d3c6f5bf3ae781834bb62b2946b.webp";